import { JSX, useRef } from "react";
import { useParams } from "react-router-dom";

import MovieBannerPlayer from "@/components/common/MovieBanner/MovieBannerPlayer.tsx";

import { useGetContentDetailPage } from "@/hooks/api/content.hooks";
import { isSafari } from "@/utils/constatns";

import MovieBannerTitle from "../common/MovieBanner/MovieBannerTitle";
import MovieBannerTop from "../common/MovieBanner/MovieBannerTop";

const DetailHero = (): JSX.Element => {
  const { id } = useParams() as { id: string };
  const { data } = useGetContentDetailPage(+id);
  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  if (!data) {
    return <></>;
  }

  return (
    <>
      <section
        className={
          "detail-hero relative mt-6 aspect-[1880/764] w-full rounded-3xl max-lg:rounded-[1.25rem] max-md:hidden max-md:aspect-auto"
        }
      >
        {!isSafari && (
          <canvas
            width={50}
            height={30}
            ref={canvasRef}
            className="ambient-canvas z-[-0] aspect-[1880/764] max-xl:hidden"
          />
        )}

        <MovieBannerPlayer
          src={data.content.bg_image.large}
          videoSrc={data.content.trailers[0]?.trailer_link ?? data.content.teaser_link}
          index={1}
          canvasRef={canvasRef}
          slideNum={1}
          onVideoEnd={() => {}}
        />
        <MovieBannerTitle
          id={+id}
          genres={data.content.genres}
          country={data.content.country}
          description={data.content.description}
          year={data.content.year}
          age_restrictions={data.content.age_restrictions}
          logo_image_rectangle={data.content.logo_image_rectangle}
          logo_image={data.content.logo_image || ""}
          rating={data.content.rating}
          imdb_rating={data.content.imdb_rating}
          kinopoisk_rating={data.content.kinopoisk_rating}
          is_serial={data.content.is_serial}
          firstSeason={(data.content.seasons && Number(data.content.seasons[0]?.id)) || 0}
        />
        <MovieBannerTop
          distributor={data.content.distributor}
          rating={data.content.rating}
          is_new={data.content.is_new}
        />
      </section>
    </>
  );
};

export default DetailHero;
